import React from 'react';
import { TruckLocation } from '../services/vendorService';
import './LocationSelector.css';

interface LocationSelectorProps {
  truckList: TruckLocation[];
  vendorName?: string;
  environment: string;
  onLocationSelect: (truckId: string) => void;
  themeStyles?: Record<string, string>;
}

const LocationSelector: React.FC<LocationSelectorProps> = ({
  truckList,
  vendorName,
  environment,
  onLocationSelect,
  themeStyles
}) => {
  // Debug logging
  console.log('LocationSelector props:', { truckList, vendorName, environment, truckListLength: truckList?.length });
  
  const handleLocationClick = (truck: TruckLocation) => {
    onLocationSelect(truck.objectId);
  };

  const getStatusDisplay = (status: string) => {
    return status === 'CLOSED' ? 'Closed' : 'Open';
  };

  const getStatusClass = (status: string) => {
    return status === 'CLOSED' ? 'status-closed' : 'status-open';
  };

  return (
    <div 
      className="location-selector"
      style={themeStyles || {}}
    >
      <div className="location-header">
        <h2 className="location-title">Select a Location</h2>
        <div className="location-info">
          {vendorName && (
            <span className="info-text">Vendor: {vendorName}</span>
          )}
        </div>
      </div>
      
      <div className="location-list">
        {truckList.length === 0 ? (
          <div className="no-locations">
            <p className="no-locations-text">No locations available</p>
            <p className="no-locations-subtitle">Please contact support for assistance</p>
          </div>
        ) : (
          truckList.map((truck) => (
            <div
              key={truck.objectId}
              className="location-item"
              onClick={() => handleLocationClick(truck)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  handleLocationClick(truck);
                }
              }}
            >
              <div className="location-content">
                <div className="location-header-row">
                  <div className="location-name">
                    {truck.name}
                  </div>
                  <div className={`location-status ${getStatusClass(truck.currentStatus || 'OPEN')}`}>
                    {getStatusDisplay(truck.currentStatus || 'OPEN')}
                  </div>
                </div>
                <div className="location-address">
                  {truck.defaultLocation?.formatted_address || "No Address Available"}
                </div>
              </div>
              <div className="location-arrow">
                <svg 
                  width="24" 
                  height="24" 
                  viewBox="0 0 24 24" 
                  fill="none" 
                  stroke="currentColor" 
                  strokeWidth="2"
                >
                  <path d="M9 18l6-6-6-6" />
                </svg>
              </div>
            </div>
          ))
        )}
      </div>
      
      <div className="location-footer">
        {/* <p className="footer-text">Select a location to view opening hours</p> */}
      </div>
    </div>
  );
};

export default LocationSelector;
